import * as yup from 'yup';

export const editRealEstateSchema = yup.object().shape({
  name: yup.string(),
  matricula: yup.number().typeError('Número inválido'),
  email: yup.string().email('El email no es válido.')
});
